import { twMerge } from 'tailwind-merge';
// import WitmetricsLogo from './WitmetricsLogo';
import SweethLogo from './SweethLogo';
import { classes } from './utils';

export type HeaderLogoProps = {
  className?: string;
  src?: string | null;
};

export default function HeaderLogo({ className, src }: HeaderLogoProps) {
  return src ? (
    <img
      className={twMerge(classes.logo, className)}
      alt="witMetrics logo"
      src={src}
    />
  ) : (
    <SweethLogo
      className={twMerge(classes.logo, classes.defaultLogo, className)}
    />
  );
}
